module.exports = __webpack_public_path__ + "img/a277e2e773b04321380845a86503eb75.513ba325.png";